import MapLayer from '../map-layer.enum';
import setCorrespondentsLayer from './correspondents-layer';

function addCorrespondentsLayer(layer: MapLayer | string, metadata?: {}) {
  return setCorrespondentsLayer(layer, metadata);
}

export default addCorrespondentsLayer;
